import { ContextAwareNavbar } from "@/components/layout/ContextAwareNavbar";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/sections/Hero";
import { Pillars } from "@/components/sections/Pillars";
import { HowItWorks } from "@/components/sections/HowItWorks";

import { CTA } from "@/components/sections/CTA";
import { WhyWeWin } from "@/components/sections/WhyWeWin";
import { Vision } from "@/components/sections/Vision";
import { EcosystemDiagram } from "@/components/sections/EcosystemDiagram";
import { SocialProof } from "@/components/sections/SocialProof";
import { SeoHead } from "@/components/seo/SeoHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="Provenance | Technology due diligence for M&A"
        description="Independent technology due diligence for investors. Verify what you're buying with the Technology Reality Score before you sign."
        path="/"
      />
      <ContextAwareNavbar />
      <main>
        <Hero />

        <WhyWeWin />
        <SocialProof />
        <EcosystemDiagram />
        <Pillars />
        <Vision />
        <HowItWorks />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
